import React, { FC, useMemo } from 'react';
import { BundleJson } from '../../../../types/bundleTypes';
import './CageInfo.scss';

type CageInfoProps = {
  bundles: BundleJson[];
  regions: { name: string; value: string }[];
};

const CageInfo: FC<CageInfoProps> = ({ bundles, regions }) => {
  const bundlesByRegion = useMemo(() => {
    return regions.map(region => {
      return {
        region: region.value,
        cages: bundles
          .filter(bundle => bundle.region === region.value)
          .map(bundle => bundle.shelfId)
          .sort((cageA, cageB) => {
            return cageA
              .toLowerCase()
              .localeCompare(cageB.toLowerCase(), undefined, {
                numeric: true,
              });
          }),
      };
    });
  }, [bundles, regions]);

  return (
    <div className="cageInfo">
      {bundlesByRegion.map((item, i) => {
        if (item.cages.length > 0) {
          return (
            <span className="cage" key={i}>
              <p className="cage_region">{item.region}</p>
              <p>
                Cage sequence: {item.cages[0]}-
                {item.cages[item.cages.length - 1]}
              </p>
              <p>Total cages: {item.cages.length}</p>
            </span>
          );
        }
      })}
    </div>
  );
};

const bundlesIsSameAmount = (prevBundles, nextBundles) => {
  return prevBundles.length === nextBundles.length;
};

export const MemoizedCageInfo = React.memo(CageInfo, bundlesIsSameAmount);
